<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Add members to group'"
        />
      </header>
      <div>
        <div class="flex justify-center items-baseline mt-4">
          <div class="input-group">
            <input
              v-model="search"
              placeholder="Search"
              type="text"
            >
          </div>
          <div class="text-xs pl-4">
            <a
              href="#"
              @click.prevent="selectAll"
              v-text="'Select All'"
            />
            |
            <a
              href="#"
              @click.prevent="selectNone"
              v-text="'Select None'"
            />
          </div>
        </div>
        <ul
          ref="membersContainer"
          class="scroll-checklist scroll-blue"
        >
          <template v-if="eligibleMemberships.data.length">
            <li
              v-for="member in eligibleMemberships.data"
              :key="member.uuid"
            >
              <input
                :id="`member-${member.uuid}`"
                v-model="selectedMembershipUuids"
                :name="`member-${member.uuid}`"
                :value="member.uuid"
                type="checkbox"
              >
              <label
                :for="`member-${member.uuid}`"
                class="checkbox"
                v-text="`${member.attributes.first_name} ${member.attributes.last_name}`"
              />
            </li>
          </template>
          <li v-if="!eligibleMemberships.data.length && !isLoading">
            <div
              class="text-sm text-center italic mb-4"
              v-text="'No results'"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        :class="{ 'load': isLoading }"
        :disabled="selectedMembershipUuids.length === 0"
        :aria-disabled="selectedMembershipUuids.length === 0"
        class="btn btn-blue"
        @click.prevent="addMembersToGroup"
        v-text="'Add members'"
      />
      <a
        class="mx-4"
        href="#"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { debounce } from 'lodash'

export default {
  name: 'AddMembersToMembershipGroupModal',
  data() {
    return {
      isLoading: false,
      search: '',
      eligibleMemberships: {
        data: [],
      },
      selectedMembershipUuids: [],
    }
  },
  computed: {
    membershipGroup() {
      return this.$store.state.membership.addMembersToMembershipGroupModal.membershipGroup
    },
    show() {
      return this.$store.state.membership.addMembersToMembershipGroupModal.open
    },
    fetchUri() {
      let uri = `memberships/membership-groups/${this.membershipGroup.attributes.uuid}/eligible-members?per_page=100`

      if (this.search) {
        uri = `${uri}&query=${this.search}`
      }

      return uri
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.getEligibleUnionMembers()
      }
    },
    search: debounce(function () {
      this.getEligibleUnionMembers()
    }, 500),
  },
  mounted() {
    this.$refs.membersContainer.onscroll= () =>  {
      let container = this.$refs.membersContainer
      //end of scroll
      if(!this.isLoading && container.scrollTop + container.clientHeight  >  (container.scrollHeight -20) && this.eligibleMemberships._links.next ) {
        this.getEligibleUnionMembers(this.eligibleMemberships.meta.pagination.current_page + 1)
      }
    }
  },

  methods: {
    selectAll() {
      this.selectedMembershipUuids = _.map(this.eligibleMemberships.data, 'uuid')
    },
    selectNone() {
      this.selectedMembershipUuids = []
    },
    getEligibleUnionMembers(page = 1) {
      this.isLoading = true

      this.$api.active().get(`${this.fetchUri}&page=${page}`)
        .then((response) => {
          if(page == 1) {
            this.eligibleMemberships = response.data
          } else {
            this.$set(this.eligibleMemberships,'data',this.eligibleMemberships.data.concat(response.data.data))
            this.$set(this.eligibleMemberships,'meta',response.data.meta)
            this.$set(this.eligibleMemberships,'_links',response.data._links)
          }
          this.isLoading = false
        })
    },
    addMembersToGroup() {
      this.isLoading = true

      this.$api.active().post(`memberships/membership-groups/${this.membershipGroup.attributes.uuid}/add-members`, {
        membershipUuids: this.selectedMembershipUuids,
      }).then((response) => {
        this.isLoading = false

        this.$emit('membershipsHaveBeenAdded')

        this.$store.commit('baseAddNotification', {
          title: 'Success!',
          text: response.data.message,
          type: 'success',
        })

        this.close()
      }).catch(() => {
        this.$store.commit('baseAddNotification', {
          title: 'Error',
          text: 'There has been an error.',
          type: 'error',
        })

        this.close()
      })
    },
    close() {
      this.selectedMembershipUuids = []

      this.$store.commit('membershipCloseAddMembersToMembershipGroupModal')
    },
  },
}
</script>
